const state = {
  driverInfo: null,
  vehicleInfo: null,
  otherInfo: null,
  timeOutNum: 60,
  timeObj: undefined,
  editContractSuccess: false,
};

// getters
const getters = {
  driverInfo(state) {
    return state.driverInfo;
  },
  vehicleInfo(state) {
    return state.vehicleInfo;
  },
  otherInfo(state) {
    return state.otherInfo;
  },
  timeOutNum(state) {
    return state.timeOutNum;
  },
  timeObj(state) {
    return state.timeObj;
  },
  editContractSuccess(state) {
    return state.editContractSuccess;
  },
};

// actions
const actions = {
  setTimeoutObj({ state, commit }) {
    let timeOutNumber = 59;
    if (state.timeObj) {
      clearInterval(state.timeObj);
      commit('setTimeObj');
    }
    commit('setTimeOutNum', timeOutNumber);
    let timeObject = setInterval(() => {
      timeOutNumber = timeOutNumber - 1;
      commit('setTimeOutNum', timeOutNumber);
      if (timeOutNumber == 0) {
        clearInterval(timeObject);
        timeObject = undefined;
      }
    }, 1000);
    commit('setTimeObj', timeObject);
  },
};

// mutations
const mutations = {
  setTimeOutNum(state, timeOutNumber) {
    state.timeOutNum = timeOutNumber;
  },
  setTimeObj(state, timeObject) {
    state.timeObj = timeObject;
  },

  setDriverInfo(state, info) {
    state.driverInfo = info;
  },
  setVehicleInfo(state, info) {
    state.vehicleInfo = info;
  },
  setOtherInfo(state, info) {
    state.otherInfo = info;
  },
  setEditContractStatus(state, data) {
    state.editContractSuccess = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
